const getCustomDateFromDate = (date: Date) => {
  const customDate = {
    day: date.getDate(),
    month: date.getMonth() + 1,
    year: date.getFullYear(),
  }

  return customDate
}

export default getCustomDateFromDate
